import React from 'react';
import ReactDOM from 'react-dom/client';
import "./global.css";
import { Home } from "./pages/Home";
import { ThemeProvider } from "styled-components";
import { ScrollButton } from "./components/ScrollButton/ScrollButton";
import { TbBrandTypescript } from "react-icons/tb";
import { FaReact, FaNodeJs } from "react-icons/fa";
import { HiOutlineChat } from "react-icons/hi";
import { RiEnglishInput } from "react-icons/ri";
import { TfiThought } from "react-icons/tfi";
import { GrMysql } from "react-icons/gr";
import { FiMusic } from "react-icons/fi";
import { TbBrandReactNative } from "react-icons/tb";
import { FaTerminal } from "react-icons/fa6";
import { MdOutlineSchedule } from "react-icons/md";
import { FaCode } from "react-icons/fa";
import { TbLayoutSidebarLeftExpand } from "react-icons/tb";
import { LuHeartHandshake } from "react-icons/lu";
import { RiAngularjsLine } from "react-icons/ri";
import { SiTailwindcss, SiOracle } from "react-icons/si";
import { HiOutlineDatabase } from "react-icons/hi";
import { RiSpeakLine  } from "react-icons/ri";
import { IoIosTimer } from "react-icons/io";
import { CiImageOn } from "react-icons/ci";
import { FiFileText } from "react-icons/fi";
import { FaGolang, FaJava } from "react-icons/fa6";
import { BsChatRightText, BsPeople } from "react-icons/bs";
import { SiPostgresql } from "react-icons/si";
import profilePicture from "./assets/profile.jpg";

const theme = {
  colors: {
    primary: "#c3dff8",
    hoverPrimary: "#38a2ff",
    cta: "#f7e9ab",
    salmon: "#fa7f72",
    whiteBg: "#fafafa",
  },
  fonts: {
    main: "'Space Grotesk', sans-serif",
    sub: "'Montserrat', sans-serif",
    fun: "'Clash Display', sans-serif",
    antique: "'Playfair Display', serif"
  },
  fontWeight: {
    light: "400",
    medium: "600",
    heavy: "800"
  },
  sizes: {
    textSize: "1.2rem",
    large: "2.6rem",
    fontSize: "16px"
  },
  borderRadius: "25px"
}

const projects = [
  { 
    name: "godeline", 
    icon: <FiFileText size="3.5rem" />,
    color: "#4fa1ff",
    summary: "Pacote golang para busca em textos",
    type: "pacote",
    technologies: [
        { name: "golang", color: "aqua" },
    ],
    githubUrl: "https://github.com/DavidEsdrs/godeline",
    description: "Este pacote golang permite a busca de textos dentro de delimitadores, isto é, se eu tenho um texto como \"esse é um <* text *> que possui alguns // delimitadores //.\" e chamar o godeline em busca de textos dentro dos delimitadores <*, *> e //, ele irá me devolver uma lista contendo: \"text\" e \"delimitadores\". Esse pacote pode ser útil na construção de aplicações que utilizem de modelos próprios de marcação de texto (Markup Languages). Aliás, ele permite até mesmo buscas simples em html, apesar de não ser adequado para uma linguagem tão complexa, tendo suas limitações. Esse foi o primeiro pacote golang feito por mim, pretendo levá-lo adiante e utilizá-lo em outros projetos."
  },
  { 
    name: "Music app", 
    icon: <FiMusic size="3.5rem" />,
    color: "#ff8fff",
    summary: "API de streaming de música",
    type: "backend",
    technologies: [
        { name: "nodejs", color: "#00801c" },
        { name: "typeorm", color: "#E83524" },
        { name: "ffmpeg", color: "#5cb85c" }
    ],
    githubUrl: "https://github.com/DavidEsdrs/music-app",
    description: "Music app é uma API REST que oferece recursos de streaming de áudio, semelhantes aos encontrados no Spotify. A API possui ferramentas de gerenciamento de playlists, músicas e usuários. Ela é protegida por autenticação via tokens JWT, além de oferecer a possibilidade do uso de refresh tokens."
  },
  { 
    name: "Eblog",
    icon: <BsChatRightText size="3.5rem" />,
    color: "#51c8ff",
    summary: "Blog com CMS headless",
    type: "backend",
    technologies: [
        { name: "nodejs", color: "#00801c" },
        { name: "jwt", color: "#d63aff" }
    ],
    githubUrl: "https://github.com/DavidEsdrs/eblog-api",
    description: `Eblog api é uma plataforma avançada de gerenciamento de blogs, projetada para fornecer recursos abrangentes de gerenciamento de postagens. Além dos recursos essenciais de um blog tradicional, essa API oferece um sistema de Content Management System (CMS) headless, permitindo um controle completo sobre o conteúdo do seu blog. O acesso aos recursos são feitos por um sistema de funções (Role Based Management System, RBMS), onde cada usuário autenticado possui um conjunto específico de permissões que determinam o que eles podem executar na API.`
  },
  { 
    name: "Evolve", 
    icon: <BsPeople size="3.5rem" />,
    color: "#c228ff",
    summary: "Rede social para interação entre usuários",
    type: "backend",
    technologies: [
        { name: "nodejs", color: "#00801c" },
        { name: "prisma", color: "#174cfc" }
    ],
    githubUrl: "https://github.com/DavidEsdrs/evolve-api",
    description: "Evolve é uma API para uma rede social que possui as principais features esperadas para um aplicativo desse tipo. A API possui recursos de fazer postagens, interações entre usuários, sistema de seguidores, curtir e comentários, entre outras funcionalidades."
  },
  { 
    name: "iproc", 
    icon: <CiImageOn size="3.5rem" />,
    color: "#4fa1ff",
    summary: "Ferramenta CLI para processamento de imagens",
    type: "cli",
    technologies: [
        { name: "golang", color: "aqua" },
    ],
    githubUrl: "https://github.com/DavidEsdrs/image-processing",
    description: "iproc é uma ferramenta CLI feita em golang que tem a finalidade de fornecer uma maneira simples e eficiente de aplicar filtros em imagens. Essa ferramenta feita em Golang, até o momento suporta imagens PNG e JPEG, dando suporte à operações simples em imagens como: Espelhar, rotacionar, aplicar filtros (grayscale), cortar e aplicar overlays."
  },
  { 
    name: "millit", 
    icon: <IoIosTimer size="3.5rem" />,
    color: "yellow",
    summary: "Pacote utilitário javascript para converter strings para milissegundos",
    type: "pacote",
    technologies: [
      { name: "javascript", color: "yellow" },
    ],
    githubUrl: "https://github.com/DavidEsdrs/millit",
    description: "Millit é um pacote javascript simples para rápida conversão de strings para milissegundos. Esse pacote tem um funcionamento semelhante ao pacote ms. A principal diferença entre ambos é que o millit não utiliza regex para seus tratamentos, o que pode ser tanto uma desvantagem, quanto uma vantagem, dependendo da situação em que será utilizado. O pacote chegou a atingir mais de 300 downloads no npm em sua semana de pico e, definitivamente, apesar de simples, é um dos projetos que eu mais me orgulho."
  },
];

const techListBackend = [
  { icon: <FaJava size={"1.8rem"} />, name: "Java" },
  { icon: <TbBrandTypescript size={"1.8rem"} />, name: "Typescript" },
  { icon: <FaNodeJs size={"1.8rem"} />, name: "NodeJs" },
  { icon: <FaGolang size={"1.8rem"} />, name: "Golang" },
];

const techListMainframe = [
  { icon: <FaTerminal size={"1.8rem"} />, name: "JCL" },
  { icon: <MdOutlineSchedule  size={"1.8rem"} />, name: "Control-M" },
  { icon: <FaCode size={"1.8rem"} />, name: "COBOL" },
  { icon: <TbLayoutSidebarLeftExpand  size={"1.8rem"} />, name: "PDF/ISPF" },
];

const techListFrontend = [
  { icon: <RiAngularjsLine size={"1.8rem"} />, name: "Angular" },
  { icon: <FaReact size={"1.8rem"} />, name: "React" },
  { icon: <TbBrandReactNative size={"1.8rem"} />, name: "React Native" },
  { icon: <SiTailwindcss size={"1.8rem"} />, name: "Tailwind" },
]

const softSkills = [
  { icon: <RiEnglishInput size={"1.6rem"} />, name: "Inglês intermediário" },
  { icon: <TfiThought size={"1.6rem"} />, name: "Pensamento analítico" },
  { icon: <HiOutlineChat size={"1.6rem"} />, name: "Comunicação clara" },
  { icon: <RiSpeakLine size={"1.6rem"} />, name: "Feedback" },
  { icon: <LuHeartHandshake size={"1.6rem"} />, name: "Trabalho em equipe" },
];

const databases = [
  { icon: <GrMysql size={"1.8rem"} />, name: "MySQL" },
  { icon: <SiPostgresql size={"1.8rem"} />, name: "PostgreSQL" },
  { icon: <SiOracle size={"1.8rem"} />, name: "Oracle" },
  { icon: <HiOutlineDatabase size={"1.8rem"} />, name: "DB2" },
];

const presentationText = <>
Olá! Sou David Esdras, Técnico Bancário de TI na <b>Caixa Econômica Federal</b>. Sou graduando em Análise e Desenvolvimento de Sistemas no IFPE Recife e técnico em programação de jogos digitais pelo NAVE Recife. Durante o curso técnico, eu dei meus primeiros passos no mundo da programação usando C-Sharp na Unity. Assim que eu pus minhas mãos no código, eu percebi que aquela era a carreira que eu queria seguir na minha vida. Na Caixa, estou tendo a oportunidade de desenvolver habilidades na atuação em Mainframes.</>

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <>
        <Home 
          projects={projects} 
          technologiesBackend={techListBackend} 
          technologiesFrontend={techListFrontend}
          technologiesMainframe={techListMainframe}
          softSkills={softSkills} 
          profilePicture={profilePicture}
          presentationText={presentationText}
          databases={databases}
        />
        <ScrollButton />
      </>
    </ThemeProvider>
  </React.StrictMode>
);